import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const initialState = { email: "", tangled: "" };

export default function AuditForm({ heading }) {
  const [form, setForm] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!form.email.trim() || !form.tangled.trim()) {
      toast.error("Please add your email and a line about what's feeling tangled.");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/contact`, {
        name: form.email.trim().split("@")[0] || "Audit enquiry",
        email: form.email.trim(),
        company: null,
        budget: null,
        message: `Audit enquiry — what's feeling tangled: ${form.tangled.trim()}`,
      });
      toast.success("Thanks — I'll be in touch within 24h.");
      setSubmitted(true);
      setForm(initialState);
    } catch (err) {
      toast.error("Something went wrong. Please email parastousaba@gmail.com");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="border border-[#0A0A0A] bg-white p-6 md:p-8"
      data-testid="audit-form"
    >
      {heading && (
        <p className="font-display text-2xl md:text-3xl tracking-tighter text-[#0A0A0A] mb-6">
          {heading}
        </p>
      )}
      <input
        name="email"
        type="email"
        value={form.email}
        onChange={handleChange}
        placeholder="Email"
        required
        data-testid="audit-input-email"
        className="w-full bg-transparent text-[#0A0A0A] placeholder:text-[#8A8A8A] px-4 py-3.5 outline-none font-sans-ibm border border-[#0A0A0A] focus:border-[#4C1D95] transition-colors"
      />
      <input
        name="tangled"
        value={form.tangled}
        onChange={handleChange}
        placeholder="What's feeling tangled?"
        required
        data-testid="audit-input-tangled"
        className="w-full mt-4 bg-transparent text-[#0A0A0A] placeholder:text-[#8A8A8A] px-4 py-3.5 outline-none font-sans-ibm border border-[#0A0A0A] focus:border-[#4C1D95] transition-colors"
      />
      <button
        type="submit"
        disabled={loading}
        className="mt-5 w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-[#4C1D95] text-[#FFFFFF] px-7 py-4 label-mono border border-[#4C1D95] hover:bg-[#0A0A0A] hover:border-[#0A0A0A] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid="audit-submit"
      >
        {loading ? "Sending…" : submitted ? "Send another" : "Book an Audit"}
        <ArrowUpRight size={16} strokeWidth={1.5} />
      </button>
    </form>
  );
}
